export const useBrand = () => {
  const config = useRuntimeConfig()
  const raw = (config.public.APP_SYSTEM as string) || 'WEBFASTER'
  const appSystem = raw.toUpperCase().trim()
  const isFastweb = appSystem === 'FASTWEB'
  const isWebfaster = appSystem === 'WEBFASTER'

  const platformUrl = isFastweb
    ? 'https://fastweb.digital'
    : 'https://webfaster.online'
  const platformName = isFastweb ? 'FastWeb.digital' : 'WebFaster.online'
  const brandName = isFastweb ? 'FastWeb' : 'WebFaster'
  const logoPath = isFastweb ? '/images/fastweb-logo.png' : ''

  return {
    appSystem,
    isFastweb,
    isWebfaster,
    platformUrl,
    platformName,
    brandName,
    logoPath,
  }
}
